export enum SupportSubject {
  BUG = 'Report a bug',
  SUGGESTION = 'Suggestion/Improvements',
  TECHNICAL = 'Technical support',
}
